import { ImportFileStatuses } from 'types/embedded/bankOperation';

export const PENDING_STATUSES = [
  ImportFileStatuses.Created,
  ImportFileStatuses.Saving,
  ImportFileStatuses.Validating,
];

export const FINAL_STATUSES = [ImportFileStatuses.Saved, ImportFileStatuses.WaitingDecision];
